import { 
	createDirectus,
	rest, 
	graphql, 
	readItem, 
	readItems,
	readCollection, 
	authentication,
	createItem,
	createUser,
	updateUser,
	registerUser,
	registerUserVerify,
	readMe,
	withToken,
	passwordRequest,
	passwordReset,
	readSingleton
}  
from '@directus/sdk';

export default defineNuxtPlugin(() => {
	const BASE_URL = useRuntimeConfig().public.apiUrl;
	const directus =  createDirectus(BASE_URL).with(rest()).with(authentication()).with(graphql())
	return {
		provide: {
			directus,
	 		readItem,
			readItems,
			readCollection, 
			authentication,
			createItem,
			createUser,
			updateUser,
			readMe,
			registerUser,
			registerUserVerify,
			withToken,
			passwordRequest,
			passwordReset,
			readSingleton
		}
	};
});